import { z } from 'zod';

/**
 * Schema allows only 6 characters, which can be letters or digits.
 */
export const schemaVorgangsnummer = z.string().min(1);

export type SchemaVorgangsnummer = z.infer<typeof schemaVorgangsnummer>;
